import request from '@/utils/request.js'

export async function createPayment(params) {
  return request({
    url: '/api/payment',
    method: 'post',
    params,
  })
}



export async function checkPaymentStatus(params) {
    return request({
      url: '/api/payment/status',
      method: 'post',
      params,
    })
  }
  